import styled from 'styled-components';
import { type DualFieldLayoutProps } from '../../../calculator/fieldComponents/withDualFieldUI';
import breakpoints from '../../../utilities/breakpoints';
import { onDecimalNumberWithPercentageKeyPress } from '../../../utilities/form';

const StyledWrapper = styled.div`
    display: flex;
    gap: 10px;
`;

const StyledUnit = styled.div`
    max-width: 95px;

    @media (max-width: ${breakpoints.xs}) {
        width: 80px;
    }
`;

const StyledValue = styled.div`
    flex: 1;
`;

const DualFieldLayout = (props: DualFieldLayoutProps) => {
    const {
        FormItem,
        Input,
        Select,
        disabled,
        onUnitChange,
        options,
        unit,
        hideLabel,
        error,
        label,
        required,
        onBlur,
        onChange,
        onFocus,
        onPressEnter,
        value,
        fieldType,
    } = props;

    return (
        <FormItem
            className={`${fieldType} ${disabled ? 'form-item-disabled' : undefined}`}
            help={error}
            label={hideLabel ? null : label}
            required={required}
            validateStatus={error ? 'error' : 'success'}
        >
            <StyledWrapper>
                {!disabled && (
                    <StyledUnit>
                        <Select
                            disabled={disabled}
                            onChange={onUnitChange}
                            options={options}
                            status={error ? 'error' : ''}
                            value={unit}
                        />
                    </StyledUnit>
                )}
                <StyledValue>
                    <Input
                        disabled={disabled}
                        onBlur={onBlur}
                        onChange={onChange}
                        onFocus={onFocus}
                        onKeyPress={onDecimalNumberWithPercentageKeyPress}
                        onPressEnter={onPressEnter}
                        status={error ? 'error' : ''}
                        value={value}
                    />
                </StyledValue>
            </StyledWrapper>
        </FormItem>
    );
};
export default DualFieldLayout;
